const API_URL = 'https://designskin-api.lukuku.co/api/product';
let data = null;
let selectedVariant = null;

async function fetchProductAPI(productId) {
  const response = await fetch(`${API_URL}?product_id=${productId}`, {
    method: 'GET',
    headers: { 'accept': 'application/json' }
  });

  if (!response.ok) throw new Error('API Error');
  return response.json();
}
async function fetchProductData(productUrl, variantId = '') {
  const cleanProductUrl = productUrl.replace('/products/', '');

  const productInfo = document.querySelector('product-info');
  const shopifySection = productInfo.closest('.shopify-section');
  const templateId = shopifySection ? shopifySection.id.replace('shopify-section-', '') : '';
  
  let url = `${cleanProductUrl}?sections=${templateId}`;
  if (variantId) {
    url += `&variant=${variantId}`;
  }
  const newUrl = new URL(window.location.origin + '/products/' + cleanProductUrl);
  newUrl.searchParams.set('variant', variantId);
  window.history.replaceState({ variantId }, '', newUrl.toString());

  const response = await fetch(url);
  const sectionData = await response.json();
  updateSection(sectionData);
  initializeProduct();
}

function updateSection(data) {
  const sectionId = Object.keys(data)[0];
  const oldSection = document.getElementById(`shopify-section-${sectionId}`);
  const newSection = document.createElement('div');
  newSection.innerHTML = data[sectionId];

  const tempDiv = document.createElement('div');
  tempDiv.innerHTML = data[sectionId];
  
  const newProductInfo = tempDiv.querySelector('product-info');
  const oldProductInfo = document.querySelector('product-info');
  oldProductInfo.setAttribute('data-product-id', newProductInfo.getAttribute('data-product-id'));
  oldProductInfo.setAttribute('data-design-value', newProductInfo.getAttribute('data-design-value')); 
  oldProductInfo.setAttribute('data-case-type-value', newProductInfo.getAttribute('data-case-type-value'));
  oldProductInfo.setAttribute('data-device-type', newProductInfo.getAttribute('data-device-type'));

  document.querySelector('.breadcrumbs--last').innerHTML = newProductInfo.querySelector('.product__title').innerHTML;

  const newMediaWrapper = newSection.querySelector('.product__media-wrapper');
  const oldMediaWrapper = oldSection.querySelector('.product__media-wrapper');

  const newProductBlocks = newSection.querySelector('.product__blocks');
  const oldProductBlocks = oldSection.querySelector('.product__blocks');

  oldMediaWrapper.replaceWith(newMediaWrapper);
  oldProductBlocks.replaceWith(newProductBlocks);
  
  // whislist button init
  document.dispatchEvent(new CustomEvent("swym:collections-loaded"));

  // [mobile] scroll to top
  if (window.innerWidth < 768) {
    window.scrollTo({
      top: 80,
      behavior: 'smooth'
    });
  }
}

function renderDeviceOptions({ currentValue, onOptionClick }) {
  const deviceOptionsElement = document.querySelectorAll('.product-variant-phone-selector-content-item-list');
  deviceOptionsElement.forEach(element => {
    element.innerHTML = '';
    const tabContent = element.dataset.tabContent;

    selectedVariant.variants
      .filter(variant => variant.manufacturer === tabContent)
      .sort((a, b) => b.title.localeCompare(a.title))
      .forEach(variant => {
        const optionElement = document.createElement('div');
        optionElement.classList.add('product-variant-phone-selector-content-item-list-item');
        if (variant.title === currentValue) optionElement.classList.add('active');
        optionElement.innerHTML = `<span>${variant.title}</span>`;
        optionElement.addEventListener('click', () => {
          onOptionClick({
            handle: selectedVariant.handle,
            variantId: variant.id
          });
          if (variant.title.includes('iPhone') || (variant.title.includes('Galaxy') && !variant.title.includes('Buds'))) {
            CookieUtils.set('selected_device', variant.title);
          }

          const selectorValue = document.querySelector('#MobileProductDrawer .product-variant-phone-selector-value');
          if (selectorValue) {
            selectorValue.textContent = variant.title;
          }
          const manufacture = document.querySelector('#MobileProductDrawer .product-variant-manufacture');
          if (manufacture) {
            manufacture.textContent = variant.manufacturer;
          }

          const mobileDrawer = document.getElementById('MobileVariantDrawer');
          if (mobileDrawer) {
            mobileDrawer.hide();
          }
        });
        element.appendChild(optionElement);
      });
  });
}

function renderPickerOptions({ type, options, currentValue, onOptionClick, designChips }) {
  const pickerTitleElement = document.querySelector(`.${type}-picker`);
  const pickerElement = document.querySelector(`.${type}-picker__options`);
  if (!pickerElement) return;
  if (type === 'case-type') {
    if (currentValue == "") return;
    pickerTitleElement.style.display = 'block';
    pickerElement.innerHTML = '';
    options.forEach(option => {
      const optionElement = document.createElement('div');
      optionElement.classList.add(`${type}-picker__option`);
      if (option.caseType === currentValue) optionElement.classList.add('active');
      optionElement.innerHTML = `<span>${option.caseType}</span>`;
      optionElement.addEventListener('click', () => onOptionClick(option));
      pickerElement.appendChild(optionElement);
    });

  } else if (type === 'design') {
    pickerElement.innerHTML = '';
    
    options.forEach(option => {
      const optionElement = document.createElement('div');
      optionElement.classList.add(`${type}-picker__option`);
      if (option.design === currentValue) optionElement.classList.add('active');
      optionElement.setAttribute('data-design-value', option.design);
      optionElement.setAttribute('data-tooltip', '');

      const designChip = designChips.find(chip => chip.designName === option.design);

      if (designChip.imageUrl) {
        const img = new Image();
        img.src = designChip.imageUrl;
        img.alt = option.design;
        img.style.opacity = '1';
        img.style.transition = 'none';
    
        img.onload = () => {
          optionElement.appendChild(img);
        };
    
      } else {
        const emptyCircle = document.createElement('div');
        emptyCircle.innerHTML = option.design[0];
        optionElement.appendChild(emptyCircle);
      }
      
      const tooltip = document.createElement('span');
      tooltip.classList.add('tooltip', 'pointer-events-none');
      tooltip.textContent = option.design;
      
      optionElement.appendChild(tooltip);
      optionElement.addEventListener('click', () => onOptionClick(option));
      pickerElement.appendChild(optionElement);
    });
  }
}

async function initializeProduct() {
  const productInfo = document.querySelector('product-info');
  if (!productInfo) return;

  productInfo.disconnectedCallback();
  productInfo.connectedCallback();

  const productData = {
    productId: productInfo.getAttribute('data-product-id'),
    designValue: productInfo.getAttribute('data-design-value'),
    caseTypeValue: productInfo.getAttribute('data-case-type-value'),
    deviceType: productInfo.getAttribute('data-device-type')
  };

  if (!data) {
    data = await fetchProductAPI(productData.productId);
    if (!data) return;
  }
  selectedVariant = data.themeGroupObjects.find(variant => variant.id === productData.productId);

  const designsObject = getDesignsForCaseType(
    productData.deviceType, 
    productData.caseTypeValue, 
    data
  );
  const caseTypesObject = getCaseTypesForDesign(
    productData.deviceType, 
    productData.designValue, 
    data
  );

  renderDeviceOptions({
    variants: selectedVariant,
    currentValue: productData.deviceType,
    onOptionClick: (option) => fetchProductData(option.handle, option.variantId)
  });

  renderPickerOptions({
    type: 'design',
    options: designsObject,
    designChips: data.themeGroupDesignChips,
    currentValue: productData.designValue,
    onOptionClick: (option) => fetchProductData(option.handle, option.variantId)
  });

  renderPickerOptions({
    type: 'case-type',
    options: caseTypesObject,
    currentValue: productData.caseTypeValue,
    onOptionClick: (option) => fetchProductData(option.handle, option.variantId)
  });

  
}

document.addEventListener('DOMContentLoaded', initializeProduct);

function getOptionsForVariant(variantTitle, productData) {
  const result = [];

  productData.themeGroupObjects.forEach(product => {
    const variant = product.variants.find(v => v.title === variantTitle);
    if (variant) {
      result.push({
        id: product.id,
        handle: product.handle,
        variantId: variant.id,
        caseType: product.metafields.productCaseTypeValue,
        design: product.metafields.productDesignValue
      });
    }
  });
  return result;
}

function getDesignsForCaseType(variantTitle, caseType, productData) {
  const products = getOptionsForVariant(variantTitle, productData);
  return products.filter(p => p.caseType === caseType);
}

function getCaseTypesForDesign(variantTitle, design, productData) {
  const products = getOptionsForVariant(variantTitle, productData);
  return products.filter(p => p.design === design);
}

  
document.addEventListener("click", function (event) {
  if (event.target && event.target.id === "custom-buy-now") {
    const variantSelector = document.querySelector('input[name="id"], select[name="id"]');
    const quantityInput = document.querySelector('input[name="quantity"]');

    const variantId = variantSelector ? variantSelector.value : event.target.dataset.variantId;
    const quantity = quantityInput ? quantityInput.value : 1;

    if (variantId) {
      const checkoutUrl = `/cart/${variantId}:${quantity}`;
      window.location.href = checkoutUrl;
    } else {
      alert("Please select a variant.");
    }
  }
});